import React, { useState } from "react";
import PageTitle from "../../shared/components/pagetitle";
import {
  ANALYSIS,
  CHEVRON_DOWN,
  DATE,
  GREEN_ARROW_UP,
  RED_ARROW_UP,
} from "../../assets";

import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { useQuery } from "react-query";
import { getAdminSearchStats } from "../../Services/admin.service";
const data = [
  { name: "Jan", value: 200 },
  { name: "Feb", value: 500 },
  { name: "Mar", value: 300 },
  { name: "Apr", value: 800 },
  { name: "May", value: 600 },
  { name: "Jun", value: 13000 },
  { name: "Jul", value: 1000 },
  { name: "Aug", value: 500 },
  { name: "Sep", value: 450 },
  { name: "Oct", value: 500 },
  { name: "Nov", value: 650 },
  { name: "Dec", value: 850 },
];
function DataReports() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("This Month");
  const { data: dashboardStats } = useQuery("stats", getAdminSearchStats, {
    refetchOnWindowFocus: false,
  });
  const chartData = dashboardStats?.data?.monthly?.map(
    (item: any, index: number) => ({
      name: dashboardStats?.data?.labels[index],
      value: Number(item),
    })
  );

  const handleSelect = (option: string) => {
    setSelected(option);
    setOpen(false);
  };

  const getStats = () => {
    switch (selected) {
      case "This Month":
        return `${dashboardStats?.data?.thisMonth || 0}%`;

        break;

      case "Last Month":
        return `${dashboardStats?.data?.prev_month_percentage_change || 0}%`;
        break;
      case "Last Year":
        return dashboardStats?.data?.prev_year_percentage_change !== null
          ? `${dashboardStats?.data?.prev_year_percentage_change || 0}%`
          : "N/A";
      default:
        return "-";
    }
  };

  const value = getStats().replace("%", "");

  return (
    <div className="p-3 sm:p-5">
      <PageTitle
        title="Data Reports"
        subtitle="Track your searches and manage overall activities"
      />

      <div className="w-full border border-borderColor rounded-xl mt-5">
        <div className="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 bg-lightGold rounded-t-xl gap-2">
          <div className="flex items-center gap-x-1">
            <span className="text-sm sm:text-[16px] font-medium">
              Case Records Summary
            </span>
          </div>
          <div className="relative">
            <div
              onClick={() => setOpen(!open)}
              className="w-fit p-2 flex space-x-2 items-center justify-between bg-white border border-[#E5E7EF] rounded-xl cursor-pointer"
            >
              <div className="flex items-center gap-x-1 w-full">
                <img src={DATE} className="w-[14px] h-[14px]" alt="" />
                <span className="text-xs font-medium text-customDark">
                  {selected}
                </span>
              </div>
              <img src={CHEVRON_DOWN} className="w-[14px] h-[14px]" alt="" />
            </div>

            {open && (
              <div className="absolute right-0 mt-1 w-[150px] rounded-md shadow-lg bg-white border border-gray-200 z-10">
                {["This Month", "Last Month", "Last Year"].map((option) => (
                  <div
                    key={option}
                    onClick={() => handleSelect(option)}
                    className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col items-start gap-y-5 px-3 sm:px-5 py-7">
          <div className="flex flex-col items-start">
            <span className="text-2xl sm:text-[32px] font-semibold text-[#080808] break-words">
              {dashboardStats?.data?.total_for_the_year} Searches
            </span>
            <div className="flex items-center gap-x-2">
              <div
                className={`w-fit px-2 py-1 rounded-3xl flex items-center justify-center border 
             ${
               value === "N/A"
                 ? "bg-gray-100 border-gray-300"
                 : Number(value) >= 0
                 ? "bg-lightGold border-globalGold"
                 : "bg-red-100 border-red-300"
             }`}
              >
                <img
                  src={
                    value === "N/A"
                      ? ""
                      : Number(value) >= 0
                      ? GREEN_ARROW_UP
                      : RED_ARROW_UP
                  }
                  className="w-[14px] h-[14px]"
                  alt=""
                />

                <span
                  className={`font-medium text-sm ml-1 ${
                    value === "N/A"
                      ? "text-gray-500"
                      : Number(value) >= 0
                      ? "text-globalGold"
                      : "text-red-600"
                  }`}
                >
                  {getStats()}
                </span>
              </div>

              {/* Label */}
              <span className="text-[#878787] font-medium text-[16px] ">
                vs {selected.toLowerCase()}
              </span>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <XAxis dataKey="name" />
              <Tooltip />
              <Bar dataKey="value" radius={[10, 10, 0, 0]}>
                {chartData?.map((entry: any, index: number) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.value > 0 ? "#FFAC06" : "#e5e7eb"}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      {/* <div className="w-full flex items-start gap-x-2 mt-5">
        <div className="w-full border border-borderColor rounded-xl">
          <div className="w-full flex items-center justify-between p-3 bg-lightGold rounded-t-xl">
            <div className="flex items-center gap-x-1 ">
              <span className="text-[16px] font-medium">Uploads by Admins</span>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-fit p-2 flex space-x-2  items-center justify-between bg-white border border-[#E5E7EF] rounded-xl">
                <div className="flex items-center gap-x-1 w-full">
                  <img src={DATE} className="w-[14px] h-[14px]" alt="" />
                  <span className="text-xs font-medium text-customDark">
                    Filter Period
                  </span>
                </div>
                <img src={CHEVRON_DOWN} className="w-[14px] h-[14px]" alt="" />
              </div>
            </div>
          </div>
          <div className="flex flex-col items-start gap-y-5 px-5 py-7">
            <div className="flex flex-col items-start">
              <div className="flex gap-x-1">
                <span className="text-[32px] font-semibold text-[#080808]">
                  23564 Uploads
                </span>
                <span className="text-globalGold mt-4 text-[16px] font-semibold">
                  {" "}
                  in the last six months
                </span>
              </div>
              <div className="flex items-center gap-x-2">
                <div className="w-fit px-2 py-1 rounded-3xl  bg-[#E8FFF4] border border-[#8FE7BE] flex items-center justify-center">
                  <img
                    src={GREEN_ARROW_UP}
                    className="w-[14px] h-[14px]"
                    alt=""
                  />
                  <span className="text-globalGold font-medium text-sm">
                    12%
                  </span>
                </div>
                <span className="text-[#878787] font-medium text-[16px] ">
                  vs last years
                </span>
              </div>
            </div>
            <div></div>
          </div>
        </div>
        <div className="w-full border border-borderColor rounded-xl">
          <div className="w-full flex items-center justify-between p-3 bg-lightGold rounded-t-xl">
            <div className="flex items-center gap-x-1 ">
              <img src={ANALYSIS} className="w-[20px] h-[20px]" alt="" />
              <span className="text-[16px] font-medium">Data Reports</span>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-fit p-2 space-x-2 flex items-center justify-between bg-white border border-[#E5E7EF] rounded-xl">
                <span className="text-xs font-medium text-customDark">
                  Total Searches
                </span>
                <img src={CHEVRON_DOWN} className="w-[14px] h-[14px]" alt="" />
              </div>
              <div className="w-fit p-2 flex space-x-2  items-center justify-between bg-white border border-[#E5E7EF] rounded-xl">
                <div className="flex items-center gap-x-1 w-full">
                  <img src={DATE} className="w-[14px] h-[14px]" alt="" />
                  <span className="text-xs font-medium text-customDark">
                    Filter Period
                  </span>
                </div>
                <img src={CHEVRON_DOWN} className="w-[14px] h-[14px]" alt="" />
              </div>
            </div>
          </div>
          <div className="flex flex-col items-start gap-y-5 px-5 py-7">
            <div className="flex flex-col items-start">
              <div className="flex gap-x-1">
                <span className="text-[32px] font-semibold text-[#080808]">
                  23465 Searches
                </span>
                <span className="text-globalGold mt-4 text-[16px] font-semibold">
                  {" "}
                  in the last six months
                </span>
              </div>
              <div className="flex items-center gap-x-2">
                <div className="w-fit px-2 py-1 rounded-3xl  bg-[#E8FFF4] border border-[#8FE7BE] flex items-center justify-center">
                  <img
                    src={GREEN_ARROW_UP}
                    className="w-[14px] h-[14px]"
                    alt=""
                  />
                  <span className="text-globalGold font-medium text-sm">
                    12%
                  </span>
                </div>
                <span className="text-[#878787] font-medium text-[16px] ">
                  vs last years
                </span>
              </div>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data}>
                <XAxis dataKey="name" />
                <Tooltip />
                <Bar dataKey="value" radius={[10, 10, 0, 0]}>
                  {data.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={entry.name === "Jun" ? "#00b341" : "#e5e7eb"}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default DataReports;
